import { Box, Typography } from "@mui/material";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
const NoAccessScreen = () => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <lord-icon
          src="https://cdn.lordicon.com/wghpqwxd.json"
          trigger="loop"
          colors="primary:#121331,secondary:#d53833"
          style={{
            width: "100px",
            height: "100px",
          }}
        ></lord-icon>
        <Typography color="#ff0000" fontSize={18}>
          No Access
        </Typography>
        <Typography color="#555">
          You do not have permission to access this page.
        </Typography>
      </Box>
    </Box>
  );
};

export default NoAccessScreen;
